import React, { useState } from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../services/api';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import PaymentMethodChooser from '../checkout/PaymentMethodChooser';

// Card/ACH chooser for one invoice from ParentInvoiceList, then redirect to checkout.
export const InvoicePayDialog = ({ invoice, onClose, returnUrl, savedCard, savedAch }) => {
  const [choice, setChoice] = useState(null);
  const [loading, setLoading] = useState(false);
  const amount = Number(invoice?.accounting?.balance_remaining || 0);
  const pay = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('/billing/pay-invoice', {
        invoice_id: invoice.pay_id, return_url: returnUrl, payment_method_choice: choice,
      });
      if (data?.checkout_url) { window.location.href = data.checkout_url; return; }
      toast.error('Could not start checkout');
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error((typeof d === 'string' ? d : d?.message) || 'Could not start checkout', { duration: 6000 });
    }
    setLoading(false);
  };
  const close = () => { setChoice(null); setLoading(false); onClose(); };
  return (
    <Dialog open={!!invoice} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="max-w-md" data-testid="invoice-pay-dialog">
        <DialogHeader>
          <DialogTitle>Confirm Payment</DialogTitle>
          <DialogDescription>{invoice?.tournament_name || invoice?.description || 'Invoice payment'}</DialogDescription>
        </DialogHeader>
        <PaymentMethodChooser baseAmount={amount} value={choice} onChange={setChoice} disabled={loading}
          savedCardLast4={savedCard?.last4 || null} savedCardBrand={savedCard?.brand || null}
          savedAchLast4={savedAch?.last4 || null} savedAchBank={savedAch?.bank_name || null} />
        <DialogFooter>
          <Button variant="outline" onClick={close} disabled={loading} data-testid="invoice-pay-cancel">Cancel</Button>
          <Button onClick={pay} disabled={!choice || loading} className="bg-emerald-600 hover:bg-emerald-700 text-white"
            data-testid="invoice-pay-confirm">
            {loading ? <><Loader2 className="h-4 w-4 mr-1 animate-spin" />Redirecting…</> : <>Continue to Checkout<ArrowRight className="h-4 w-4 ml-1" /></>}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InvoicePayDialog;
